var Gallery = function () {

	this.init = function () {

		this.slider();

	}

	this.slider = function () {

		$('[data-component="gallery"] .div-to-slide').slick({
			slidesToShow: 1,
			centerMode: true,
			arrows: false,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 2000,
					settings: {
						arrows: true,
						variableWidth: true,
					}
				},
				{
					breakpoint: 768,
					settings: {
						arrows: false,
						variableWidth: false,
						centerPadding: '20px'
					}
				}
			]
		});

	}

	return this.init();

}
